import React from 'react'
import './Tooltip.scss'

interface IProps {
  className?: string,
  header?:any,
  children?:any
}

const Tooltip = ({ className,header,children }:IProps) => {
    return <div className={`tooltipContainer ${className}`}>
        <div className='tooltipHeader'>
            {header}
        </div>
        <div className='tooltipBody'>
            {children}
        </div>
    </div>
}

export default Tooltip